import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const DialogMessage = (props) => {
    return (
        <Wrap>
            <Title Size={props.Size}>
                {props.Title}
            </Title>
            <Message Size={props.Size} Align={props.Align} Selectable={props.Selectable}>
                {props.Message}
            </Message>
        </Wrap>
    );
}

DialogMessage.propTypes = {
    Title: PropTypes.string.isRequired,
    Message: PropTypes.any.isRequired,
    Align: PropTypes.string,
    Selectable: PropTypes.bool,
};

const Wrap = styled.div`
`;
const Title = styled.div`
    margin: 10px 0;
    font-size: ${props => props.Size ? props.Size : "16px"};
    font-weight: bold;

    ${props => props.Selectable ? css`
    -webkit-touch-callout: text; /* iOS Safari */
    -webkit-user-select: text; /* Safari */
    -khtml-user-select: text; /* Konqueror HTML */
    -moz-user-select: text; /* Firefox */
    -ms-user-select: text; /* Internet Explorer/Edge */
    user-select: text; /* Non-prefixed version, currently supported by Chrome and Opera */
    ` : ``};
`;
const Message = styled.div`
    margin: 10px 0;
    font-size: ${props => props.Size ? props.Size : "16px"};
    text-align: ${props => props.Align ? props.Align : "center"};
    padding: 0 10px;
    word-break: break-all;

    ${props => props.Selectable ? css`
    -webkit-touch-callout: text; /* iOS Safari */
    -webkit-user-select: text; /* Safari */
    -khtml-user-select: text; /* Konqueror HTML */
    -moz-user-select: text; /* Firefox */
    -ms-user-select: text; /* Internet Explorer/Edge */
    user-select: text; /* Non-prefixed version, currently supported by Chrome and Opera */
    ` : ``};
`;
